import store from './store'

export default function install(registry) {
  return store(registry)
}
